export function UndoRedo (pEditor)
{
  let pUndoButton,
      pRedoButton,
      undoHash = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      undoStack = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      undoPointer = -1,
      redoPointer = -1,
      coUndoPoints = 0,
      isUndoRedoInited = false,
      isUndoRedoExecuting = false,
      isUndoRedoExecuted = false,
      isUndoKeyPressed = true,
      isStopSaveUndo = false,
      isUndoSaved = false,
      coUndoPointsTM = false;


  this.init = () =>
  {
    if (!isUndoRedoInited)
    {
      isUndoRedoInited = true;
      pUndoButton = pEditor.pToolbar.getButtonByName('Undo');
      pRedoButton = pEditor.pToolbar.getButtonByName('Redo');
      saveUndoDo();
      return true;
    }

    return false;
  };


  this.reInit = () =>
  {
    undoStack.forEach((el, i, a) => a[i] = i);
    undoPointer = -1;
    redoPointer = -1;
    isUndoRedoInited = false;
    isUndoRedoExecuting = false;
    isUndoRedoExecuted = false;
    isUndoSaved = false;
    isUndoKeyPressed = true;
    isStopSaveUndo = false;
  };


  this.setPressedKeyInterval = () =>
  {
    isUndoKeyPressed = true;
    saveUndo();
  };


  const saveUndo = isImmediate =>
  {
    var undoSaveContent;

    if (isUndoRedoInited && !isStopSaveUndo)
    {
      if (!isUndoSaved)
      {
        if (isImmediate || isUndoKeyPressed)
        {
          undoSaveContent = getUndoSaveContent();

          if (undoHash[undoStack[undoPointer]] && undoHash[undoStack[undoPointer]].cont !== undoSaveContent && !pEditor.copyPaste.checkPasteContainersAndMarkers(undoSaveContent))
          {
            isUndoSaved = true;
            saveUndoDo(false, null, true);
          }
        }
      }
      else
      {
        isUndoSaved = false;
      }

      if (isImmediate)
      {
        isUndoKeyPressed = true;
      }
    }
  };


  const saveUndoDo = (isReplace, undoSaveContent, isSaveUndoCall, isImmediate) =>
  {
    var i,
        sp;

    if (isUndoRedoInited && (isImmediate || !isStopSaveUndo || undoSaveContent != null))
    {
      undoSaveContent = getUndoSaveContent(undoSaveContent);

      if (undoSaveContent === null)
      {
        return false;
      }

      if (!isSaveUndoCall && undoHash[undoStack[undoPointer]] && undoSaveContent == undoHash[undoStack[undoPointer]].cont)
      {
        return true;
      }

      if (!isReplace)
      {
        undoPointer++;

        if (undoPointer > 10)
        {
          undoPointer = 10;

          sp = undoStack[0];

          for (i = 0; i < undoStack.length - 1; i++)
          {
            undoStack[i] = undoStack[i + 1];
          }

          undoStack[10] = sp;
        }

        redoPointer = undoPointer;
        pEditor.pThis.EditorDataChanged.fireHandlers();
      }

      if (undoHash[undoStack[undoPointer]])
      {
        undoHash[undoStack[undoPointer]].cont = undoSaveContent;
        undoHash[undoStack[undoPointer]].range = getUndoPoint();
      }

      pUndoButton.refreshState();
      pRedoButton.refreshState();
    }
  };


  const getUndoSaveContent = currentHTML =>
  {
    const reScripts = new RegExp('usercustomscript', 'i');

    if (currentHTML == null)
    {
      try
      {
        pEditor.setWaContentMarker();
        currentHTML = pEditor.iFrameDoc.body.innerHTML;
      }
      catch (err)
      {
        return null;
      }
    }

    if (reScripts.test(currentHTML))
    {
      currentHTML = pEditor.helpers.userJavascript.restore(currentHTML);
    }

    if (pEditor.contentChecker.reAnchors.test(currentHTML))
    {
      currentHTML = pEditor.anchor.restoreAnchors(currentHTML);
    }

    return currentHTML;
  };


  const getUndoRestoreContent = currentHTML =>
  {
    currentHTML = pEditor.helpers.userJavascript.collect(currentHTML);
    currentHTML = pEditor.anchor.collectAnchors(currentHTML);

    return currentHTML;
  };


  const getUndoPoint = () =>
  {
    let currentRange = pEditor.range.getCurrent(true);

    if (currentRange)
    {
      const endNode = currentRange.endContainer,
            parentNode = endNode.parentNode,
            isElementNode = (parentNode.nodeType === 1),
            parentNodeNum = (isElementNode ? parentNode.getAttribute('data-wacontent') : null);

      let node = endNode,
          prevNode,
          endOffset = currentRange.endOffset,
          nodesCounter = 0;

      if (endNode.nodeType === 3)
      {
        let coOffset = 0;

        while ((node = node.previousSibling) && node.nodeType === 3)
        {
          coOffset += (node.nodeValue) ? node.nodeValue.length : 0;
          prevNode = node;
        }

        endOffset += coOffset;
      }

      if (node)
      {
        while (node = node.previousSibling)
        {
          if (!(node.nodeType === 3 && prevNode && prevNode.nodeType === 3))
          {
            nodesCounter++;
          }

          prevNode = node;
        }
      }

      return { parentNodeNum, nodesCounter, endOffset };
    }

    return { parentNodeNum: 0, nodesCounter: 0, endOffset: 0 };
  };


  const setUndoPoint = point =>
  {
    let parentNode = pEditor.iFrameDoc.querySelector(`[data-wacontent="${point.parentNodeNum}"]`),
        node = (parentNode ? parentNode.childNodes[point.nodesCounter] : null);

    if (node)
    {
      try
      {
        let selection = pEditor.iFrame.getSelection();
        selection.removeAllRanges();
        let objRange = pEditor.iFrameDoc.createRange();
        objRange.setStart(node, point.endOffset);
        objRange.setEnd(node, point.endOffset);
        selection.addRange(objRange);
      }
      catch (err) {}
    }
  };


  const queryExecUndoRedo = (pButton, command) =>
  {
    if (command == 'undo')
    {
      return (undoPointer > 0);
    }
    else if (command == 'redo')
    {
      return (redoPointer > undoPointer);
    }
  };


  const execUndoRedo = (pButton, command) =>
  {
    if (isUndoRedoExecuting)
    {
      setTimeout(function () { isUndoRedoExecuting = false; }, 3000);
      return;
    }

    var undoSaveContent;
    var stopExecTM = 17;

    isUndoRedoExecuting = true;

    if (command == 'undo')
    {
      undoSaveContent = getUndoSaveContent();

      if (undoPointer > 0 && undoHash[undoStack[undoPointer - 1]] && undoHash[undoStack[undoPointer - 1]].cont != null && undoSaveContent !== null)
      {
        isUndoRedoExecuted = true;

        if (undoPointer == redoPointer && undoHash[undoStack[undoPointer]])
        {
          undoHash[undoStack[undoPointer]].cont = undoSaveContent;
          undoHash[undoStack[undoPointer]].range = getUndoPoint();
        }

        undoPointer--;

        pEditor.iFrameDoc.body.innerHTML = getUndoRestoreContent(undoHash[undoStack[undoPointer]].cont);
        pEditor.anchor.reCollectAnchors();
        pEditor.checkAllImages();
        setUndoPoint(undoHash[undoStack[undoPointer]].range);

        undoSaveContent = getUndoSaveContent();

        if (undoSaveContent !== null)
        {
          undoHash[undoStack[undoPointer]].cont = undoSaveContent;
          undoHash[undoStack[undoPointer]].range = getUndoPoint();
        }

        pEditor.pThis.EditorDataChanged.fireHandlers();
      }
    }
    else if (command == 'redo')
    {
      if (redoPointer > undoPointer)
      {
        undoPointer++;

        if (undoHash[undoStack[undoPointer]] && undoHash[undoStack[undoPointer]].cont != null)
        {
          isUndoRedoExecuted = true;
          pEditor.iFrameDoc.body.innerHTML = getUndoRestoreContent(undoHash[undoStack[undoPointer]].cont);
          pEditor.anchor.reCollectAnchors();
          pEditor.checkAllImages();
          setUndoPoint(undoHash[undoStack[undoPointer]].range);

          undoSaveContent = getUndoSaveContent();

          if (undoSaveContent !== null)
          {
            undoHash[undoStack[undoPointer]].cont = undoSaveContent;
            undoHash[undoStack[undoPointer]].range = getUndoPoint();
          }

          pEditor.pThis.EditorDataChanged.fireHandlers();
        }
      }
    }

    pUndoButton.refreshState();
    pRedoButton.refreshState();
    setTimeout(function () { isUndoRedoExecuting = false; }, stopExecTM);
  };


  this.saveUndo = saveUndo;
  this.saveUndoDo = saveUndoDo;
  this.queryExecUndoRedo = queryExecUndoRedo;
  this.execUndoRedo = execUndoRedo;

  Object.defineProperty(this, 'isContentChanged', { get: () => (undoPointer > 0) });
  Object.defineProperty(this, 'isUndoRedoExecuting', { get: () => isUndoRedoExecuting, set: v => { isUndoRedoExecuting = v }});
  Object.defineProperty(this, 'isUndoRedoExecuted', { get: () => isUndoRedoExecuted, set: v => { isUndoRedoExecuted = v }});
  Object.defineProperty(this, 'isUndoKeyPressed', { get: () => isUndoKeyPressed, set: v => { isUndoKeyPressed = v }});
  Object.defineProperty(this, 'isStopSaveUndo', { get: () => isStopSaveUndo, set: v => { isStopSaveUndo = v }});
}
